<script>
    export let company_data;

    let company_name = company_data.name;
    let footer_description = company_data.footer_page.description
    let phones = company_data.phones;
    let whatsapp = company_data.whatsapp;

    let company_address = company_data.address;
    let location_google_maps_url = company_data.location_google_maps_url;
</script>

<style>
    .section-gap {
        padding: 120px 0;
    }

    .footer-area {
        background-color: #222;
    }

    .single-footer-widget {
        color: #777;
        font-family: "Poppins", sans-serif;
        font-size: 14px;
        font-weight: 300;
        line-height: 1.625em;
        position: relative;
    }

    .footer-area .number {
        font-size: 24px;
        font-weight: 600;
        line-height: 30px;
    }
    .footer-area .number a {
        text-decoration: none;
        color: #f42f2c;
    }
</style>

<main>
    <footer class="footer-area section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-3  col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h4 class="text-white">{company_name}</h4>
                        <p>{footer_description}</p>
                    </div>
                </div>
                <div class="col-lg-4  col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h4 class="text-white">Ligue e faça seu pedido!</h4>
                        <p class="number">
                            {#each phones as phone, i}
                                {#if i > 0}
                                <br>
                                {/if}
                                <a href="{phone.url}">{phone.description}</a>
                            {/each}
                            <br><br>
                            <span class="text-white">Whatsapp</span><br />
                            <a href="{whatsapp.url}">{whatsapp.description}</a>
                        </p>
                    </div>
                </div>

                <div class="col-lg-5  col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h4 class="text-white">Endereço</h4>
                        <link
                            rel="stylesheet"
                            href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css" />

                        <p>
                            <link
                                rel="stylesheet"
                                href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css" />
                        </p>{company_address}
                        <br />
                    </div>
                    <!-- <iframe
                        title="location"
                        src="{location_google_maps_url}"
                        width="250"
                        height="250"
                        frameborder="0"
                        style="border:0"
                        allowfullscreen /> -->
                    <div class="mapouter">
                        <div class="gmap_canvas">
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <iframe width="250" height="250" id="gmap_canvas" src="{location_google_maps_url}" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                            <a href="https://embedgooglemap.net/maps/6">
                            </a>
                            <br>
                            <style>.mapouter{position:relative;text-align:right;height:250px;width:250px;}</style>
                            <a href="https://www.embedgooglemap.net">google map embed responsive</a>
                            <style>.gmap_canvas {overflow:hidden;background:none!important;height:250px;width:250px;}</style>
                        </div>
                    </div>

                </div>
            </div>
            <div class="footer-bottom d-flex justify-content-between align-items-center flex-wrap" />
        </div>
    </footer>
</main>
